var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/camelcase */
import { debounce } from 'lodash';
import { API_MISSING_TRANSLATIONS } from '../helpers/api';
import { logger, loggerError } from '../helpers/Log';
var missingToSent = new Set();
var sent = new Set();
var APICall = function (_a) {
    var application = _a.application, language = _a.language, translation = _a.translation, access_token = _a.access_token;
    try {
        return fetch("".concat(API_MISSING_TRANSLATIONS), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(access_token),
            },
            body: JSON.stringify({
                app: application,
                language: language,
                translation: translation,
            }),
        });
    }
    catch (error) {
        loggerError('fail submitting missing translations');
        loggerError(error);
        return new Promise(function (resolve) { return resolve(null); });
    }
};
var call = debounce(function (application, access_token) {
    var e_1, _a;
    try {
        var map_1 = new Map();
        missingToSent.forEach(function (item) {
            var _a;
            if (map_1.has(item.language)) {
                var obj = map_1.get(item.language);
                obj[item.key] = item.key;
                map_1.set(item.language, obj);
            }
            else
                map_1.set(item.language, (_a = {}, _a[item.key] = item.key, _a));
        });
        try {
            for (var _b = __values(map_1.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var lang = _c.value;
                APICall({
                    application: application,
                    language: lang,
                    translation: map_1.get(lang),
                    access_token: access_token,
                }).then(function () { return missingToSent.clear(); });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    catch (error) {
        console.error('something went wrong on missing translations', error);
    }
}, 20000);
export function missingTranslations(_a) {
    var application = _a.application, language = _a.language, key = _a.key, access_token = _a.access_token;
    var unique = "".concat(application, ",").concat(language, ",").concat(key);
    logger('adding missing translations: ', unique);
    if (!sent.has(unique)) {
        sent.add(unique);
        missingToSent.add({ language: language, key: key });
    }
    else
        return;
    call(application, access_token);
}
//# sourceMappingURL=missingTranslations.js.map